import {Container, Typography} from "@mui/material";
import React from "react";

export default function Companies() {
    return (
        <Container>
            <Typography variant="h1">Entreprises</Typography>
        </Container>
    )
}